import JP_ITEM_MESSAGE_CODE from "./jp-items";
import JP_MESSAGES_MESSAGE_CODE from "./jp-messages";

const JP_MESSAGE_CODE = {
    ...JP_ITEM_MESSAGE_CODE,
    ...JP_MESSAGES_MESSAGE_CODE,
};

export default JP_MESSAGE_CODE;
